var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.7,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,61.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,14.5l-24.8,11v16.5c0,15,10.4,28.9,24.3,32.3l0.5,0.1l0.5-0.1C58.9,71,69.3,57.1,69.3,42.1V25.5 L44.5,14.5z M65.7,42.1c0,13.3-9.1,25.5-21.2,28.6c-12.1-3.1-21.2-15.4-21.2-28.6V27.9l21.2-9.4l21.2,9.4V42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,27.4c-7.6,0-13.8,6.2-13.8,13.8c0,7.6,6.2,13.8,13.8,13.8s13.8-6.2,13.8-13.8 C58.3,33.6,52.1,27.4,44.5,27.4z M44.5,51.8c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5S55,35.5,55,41.3 C55,47.1,50.3,51.8,44.5,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,70.7c6.5-1.7,12.1-6,16-11.7c-4.7-2.6-11.7-3.9-16-3.9c-4.3,0-11.2,1.3-16,3.9 C32.4,64.7,38,69,44.5,70.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySecurity);
export default __webpack_public_path__ + "static/media/my-security.ab285c70c24a6d9ee4ca1c63317d5a70.svg";
export { ForwardRef as ReactComponent };